import React, { useRef, useEffect, useState } from "react";
import { BounceLoader } from "react-spinners";
import PaginationButton from "./PaginationButton";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";

const HeaderBar = ({
  backPage = null,
  backPageAction = null,
  nextPage = null,
  nextPageAction = null,
  nextPageEnabled = true,
  nextPageLoading = false,
  className = '',
  children
}) => {
  const { actions, state } = useStateMachineWrapper();

  const headerRef = useRef(null);
  const backBtnRef = useRef(null);
  const nextBtnRef = useRef(null);

  const [backWidth, setBackWidth] = useState(null);
  const [nextWidth, setNextWidth] = useState(null);

  const lastIntersectingRef = useRef(state.session.headerVisible);

  // Measure button widths after mount or update
  useEffect(() => {
    if (backBtnRef.current) {
      setBackWidth(backBtnRef.current.offsetWidth);
    }
    if (nextBtnRef.current) {
      setNextWidth(nextBtnRef.current.offsetWidth);
    }
  });

  // Intersection observer logic
  useEffect(() => {
    const observerCallback = ([entry]) => {
      if (headerRef.current && lastIntersectingRef.current !== entry.isIntersecting) {
        lastIntersectingRef.current = entry.isIntersecting;
        actions.update({ headerVisible: entry.isIntersecting });
      }
    };

    const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, [actions]);


  // True if either back or next exists
  const hasAnyNav = backPage !== null || nextPage !== null;

  // Determine ideal placeholder width
  const idealWidth = backWidth || nextWidth || 0;

  return (
    <div ref={headerRef} className={`flex items-center ${className}`}>

      {/* LEFT SLOT */}
      <div className="flex-none btn-bf-wrap" style={{ width: hasAnyNav ? idealWidth : undefined }}>
        {backPage !== null ? (
          <div ref={backBtnRef}>
            <PaginationButton
              mode="back"
              page={backPage}
              action={backPageAction}
              enabled={!nextPageLoading}
            />
          </div>
        ) : hasAnyNav ? (
          // Placeholder matched to button width
          <div style={{ width: idealWidth, height: 1 }} />
        ) : null}
      </div>

      {/* CENTER */}
      <div className="flex-1 mx-1">
        {children}
      </div>

      {/* RIGHT SLOT */}
      <div className="flex-none btn-bf-wrap" style={{ width: hasAnyNav ? idealWidth : undefined }}>

        {nextPageLoading === true ? (
          <BounceLoader
            className="mx-auto mt-1"
            size={'3rem'}
            color={'#FFC72D'}
            speedMultiplier={0.75}
          />
        ) : nextPage !== null ? (
          <div ref={nextBtnRef}>
            <PaginationButton
              mode="next"
              page={nextPage}
              action={nextPageAction}
              enabled={nextPageEnabled}
            />
          </div>
        ) : hasAnyNav ? (
          <div style={{ width: idealWidth, height: 1 }} />
        ) : null}

      </div>
    </div>
  );
};

export default HeaderBar;
